// src/components/profile-components/WatchedHistoryList.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, History, ArrowLeft } from 'lucide-react';

import { getWatchedHistory } from '../../services/profileService';
import VerticalContentCard from '../Category/VerticalContentCard'; 
import { useAuthContext } from '../../context/AuthContext'; 

export function WatchedHistoryList() {
    const [historyData, setHistoryData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [errorStatus, setErrorStatus] = useState(null);
    
    const { profileUpdateKey } = useAuthContext();

    useEffect(() => {
        const fetchHistory = async () => {
            console.log("HISTORY LIST DEBUG: 1. Fetching history started."); 
            try {
                const responseData = await getWatchedHistory();
                
                // ✅ اصلاح طلایی: مدیریت پاسخ‌های مختلف (صفحه‌بندی شده یا لیست ساده)
                const rawItems = responseData?.results || (Array.isArray(responseData) ? responseData : []);
                
                // ✅ استخراج ایمن محصولات با Optional Chaining
                const products = rawItems
                    .map(historyItem => historyItem?.product_details || historyItem?.product)
                    .filter(product => product != null && typeof product === 'object'); 
                
                // حذف موارد تکراری بر اساس ID (برای تمیزی لیست)
                const uniqueProducts = Array.from(new Map(products.map(p => [p.id, p])).values());
                
                setHistoryData(uniqueProducts.slice(0, 10));

                console.log("HISTORY LIST DEBUG: 2. Fetch Success. Items found:", uniqueProducts.length);

            } catch (error) {
                console.error("HISTORY LIST DEBUG: 3. Fetch Error:", error.message);
                setIsError(true);
                if (error.response) {
                    setErrorStatus(error.response.status);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchHistory();
    }, [profileUpdateKey]); 


    // ----------------------
    // ۱. حالت بارگذاری (Loading)
    // ----------------------
    if (isLoading) {
        return (
            <div className="flex justify-center items-center p-10 rtl">
                <Loader2 className="w-6 h-6 animate-spin text-purple-700" />
                <span className="mr-3 text-gray-600 font-medium">در حال بارگذاری تاریخچه...</span>
            </div>
        );
    }

    // ----------------------
    // ۲. حالت خطا (Error)
    // ----------------------
    if (isError) {
        if (errorStatus === 401) {
             return (
                <div className="p-6 bg-white rounded-lg shadow-sm text-center text-gray-500 rtl border border-gray-100">
                    <History className="w-10 h-10 mx-auto mb-3 text-gray-400" />
                    <p className="font-medium">تاریخچه بازدید</p>
                    <p className="text-[11px] mt-2">برای مشاهده تاریخچه، ابتدا وارد شوید.</p>
                </div>
            );
        }
        return (
            <div className="p-4 bg-red-50 text-red-700 rounded-lg rtl text-center border border-red-100">
                خطا در دریافت تاریخچه بازدید.
            </div>
        );
    }

    // ----------------------
    // ۳. حالت لیست خالی (Empty State)
    // ----------------------
    if (historyData.length === 0) {
        console.log("HISTORY LIST DEBUG: 4. Displaying Empty State."); 
        return (
            <div className="p-10 bg-white rounded-lg shadow-sm text-center text-gray-500 rtl border border-gray-100">
                <History className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                <p className="font-medium text-gray-700">تاریخچه بازدید شما خالی است</p>
                <p className="text-[11px] mt-2">محتواهایی که مشاهده می‌کنید در اینجا نمایش داده می‌شوند.</p>
            </div>
        );
    }

    // ----------------------
    // ۴. حالت موفقیت (Success)
    // ----------------------
    return (
        <div className="space-y-4 rtl text-right">
            {/* هدر بخش */}
            <div className="flex justify-between items-center">
                <h3 className="text-gray-800 font-bold text-[12px] md:text-xl">
                    تاریخچه بازدید شما
                </h3>
                <Link 
                    to="/profile/history" 
                    className="text-xs font-medium text-gray-500 hover:text-purple-900 transition flex items-center"
                >
                    <span>بیشتر</span>
                    <ArrowLeft className="w-4 h-4 mr-1" />
                </Link>
            </div>
            
            {/* کراسل افقی با اسکرول نرم */}
            <div className="flex overflow-x-auto space-x-4 space-x-reverse py-2 no-scrollbar">
                {historyData.map(product => (
                    <div 
                        key={product.id} 
                        className="w-[280px] md:w-[320px] flex-shrink-0"
                    >
                        <VerticalContentCard data={product} />
                    </div>
                ))}
            </div>
        </div>
    );
}